<!-- Navbar -->
<!-- <Loader :loading="loading" /> -->
<HomeNavBar @new_report="addReportToHome" @addPortal="addNewPortal" @newSegment="addNewSegement" @new_temp_post="addTemporaryPost" @new_document="addDocumentApproval" @active-profile-loaded="onActiveProfileLoaded"/>
<InactivityModal/>

<!-- Main Content -->
<section>
  <div class="container-fluid">
    <div class="row content-section bg-transparent flex-lg-nowrap gx-3 gy-3">

<div class="rounded col-lg-3 portals-sidebar">
        <AllPortals @portal_profile="portalProfile" @portal_selected="fetchPostsByPortal" @portalAccepted="handlePortalAccepted" ref="portals" :portal_admin="portal_admin" @sub_portals="handle_sub_portals" @clear_reports="clear_reports_filter" />
      </div>

      <!-- Middle Content -->
      <div :class="[activeTab === 'personal_profiles' ? 'col-xl-9 col-lg-9' : 'col-xl-6 col-lg-6', 'col-md-12']">
        <div class="card rounded bg-white border-0 mt-1 p-2">
          <div class="margin-0">
            <div class="d-flex align-items-start justify-content-between gap-2 flex-wrap">
              <h3 class="portal-heading mb-0">{{$route.params.portal_name}}</h3>
            </div>
            <p class="portal-meta-list text-xxs d-flex align-items-center flex-wrap gap-2 mb-0">
              <span v-if="$route.params.is_public === 'false'" class="portal-meta-pill rounded d-none">
                <i class="bx bxs-lock-alt me-2"></i>

                <span v-if="school_domain">Private </span>
                <span v-else>Private Portal</span>
              </span>
              <span v-else class="portal-meta-pill rounded">
                <i class="bx bx-globe me-2"></i>
                <span v-if="school_domain">Public</span>
                <span v-else>Public Portal</span>
              </span>

              <span v-if="(user_details.user_role === 'admin' || portal_admin) && $route.params.is_public === 'false'" class="portal-meta-pill rounded pointer" role="button" tabindex="0" @click="open_portal_members_tab" @keydown.enter.prevent="open_portal_members_tab">
                <i class='bx bxs-user-account me-2'></i> {{ portal_count }} Members
              </span>
            </p>

            <!-- Portal Settings Button (Side Modal Trigger) -->
          </div>

          <div class="col h-100 overflow-auto  mt-2">
            <!-- iPad (md) & Desktop View: Centered Tabs -->
            <div class="portal-tabs-card portal-tabs-strip">
                <div class="tabs-wrapper d-flex justify-content-between align-items-center px-2 py-1">
              <div class="scrollable-tabs" ref="tabsContainer">
                <ul class="nav nav-tabs flex-nowrap text-xxs portal-icon-tabs" id="portal-tabs" role="tablist">
                  <!-- Your Feed -->
                  <button
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'your_feed' }"
                    @click="activeTab = 'your_feed'"
                    id="tab-your-feed"
                    data-bs-toggle="tab"
                    data-bs-target="#normal_loans_info"
                    type="button"
                    role="tab"
                    aria-controls="normal_loans_info"
                    :aria-selected="activeTab === 'your_feed'"
                  ><i class="bi bi-list-task"></i><span>Your Feed</span></button>

                  <!-- Your Voice -->
                  <button
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'voice' }"
                    @click="activeTab = 'voice'"
                    id="tab-your-voice"
                    data-bs-toggle="tab"
                    data-bs-target="#top_loans_info"
                    type="button"
                    role="tab"
                    aria-controls="top_loans_info"
                    :aria-selected="activeTab === 'voice'"
                  ><i class="bi bi-mic-fill"></i><span>Your Voice</span></button>

                  <!-- Portal Requests -->
                  <button
                    v-if="can_manage_portal()"
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'requests' }"
                    @click="activeTab = 'requests'"
                    id="tab-portal-requests"
                    data-bs-toggle="tab"
                    data-bs-target="#portal_requests"
                    type="button"
                    role="tab"
                    aria-controls="portal_requests"
                    :aria-selected="activeTab === 'requests'"
                  >
                <i class="bi bi-person-check-fill"></i>
                <span v-if="school_domain">Requests</span>
                <span v-else>Requests</span></button>

                  <!-- Mentors -->
                  <button
                    v-if="portal_profile && portal_profile.mentoring_type && (portal_profile.mentoring_type.toLowerCase() === 'both' || portal_profile.mentoring_type.toLowerCase() === 'mentee')"
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'mentors' }"
                    @click="activeTab = 'mentors'"
                    id="tab-portal-mentors"
                    data-bs-toggle="tab"
                    data-bs-target="#portal_mentors"
                    type="button"
                    role="tab"
                    aria-controls="portal_mentors"
                    :aria-selected="activeTab === 'mentors'"
                  ><i class="bi bi-person-workspace"></i><span>Mentors</span></button>

                  <!-- Mentees -->
                  <button
                    v-if="portal_profile && portal_profile.mentoring_type && (portal_profile.mentoring_type.toLowerCase() === 'both' || portal_profile.mentoring_type.toLowerCase() === 'mentor')"
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'mentees' }"
                    @click="activeTab = 'mentees'"
                    id="tab-portal-mentees"
                    data-bs-toggle="tab"
                    data-bs-target="#portal_mentees"
                    type="button"
                    role="tab"
                    aria-controls="portal_mentees"
                    :aria-selected="activeTab === 'mentees'"
                  ><i class="bi bi-people-fill"></i><span>Mentees</span></button>
                  <!-- Members -->
                  <button
                    v-if="can_manage_portal()"
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'members' }"
                    @click="activeTab = 'members'"
                    id="tab-portal-members"
                    data-bs-toggle="tab"
                    data-bs-target="#portal_members"
                    type="button"
                    role="tab"
                    aria-controls="portal_members"
                    :aria-selected="activeTab === 'members'"
                  >
                <i class="bi bi-people-fill"></i>
                <span v-if="school_domain">Members</span>
                <span v-else>Members</span></button>

                  <button
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center d-none"
                    :class="{ active: activeTab === 'personal_profiles' }"
                    @click="open_personal_profile_forms_tab"
                    id="tab-personal-profiles"
                    data-bs-toggle="tab"
                    data-bs-target="#personal_profiles"
                    type="button"
                    role="tab"
                    aria-controls="personal_profiles"
                    :aria-selected="activeTab === 'personal_profiles'"
                  >
                <i class="bi bi-person-vcard-fill"></i>
                <span>Forms</span></button>

                  <!-- Permissions -->
                  <button
                    v-if="(user_details.user_role === 'admin'|| user_details.user_role === 'organization admin' || portal_admin) && $route.params.is_public === 'false'"
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'permissions' }"
                    @click="open_portal_permissions_tab"
                    id="tab-portal-permissions"
                    data-bs-toggle="tab"
                    data-bs-target="#portal_permissions"
                    type="button"
                    role="tab"
                    aria-controls="portal_permissions"
                    :aria-selected="activeTab === 'permissions'"
                  ><i class="bi bi-shield-lock-fill"></i><span>Permissions</span></button>

                  <!-- Events -->
                  <button
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'events' }"
                    @click="activeTab = 'events'"
                    id="tab-events"
                    data-bs-toggle="tab"
                    data-bs-target="#events"
                    type="button"
                    role="tab"
                    aria-controls="events"
                    :aria-selected="activeTab === 'events'"
                  ><i class="bi bi-calendar-event-fill"></i><span>Events</span></button>
                  <!-- Document/Media Approval -->
                  <button
                    v-if="$route.params.is_public === 'false'"

                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'documents' }"
                    @click="activeTab = 'documents'"
                    id="tab-doc-approval"
                    data-bs-toggle="tab"
                    data-bs-target="#document_approval"
                    type="button"
                    role="tab"
                    aria-controls="portal_members"
                    :aria-selected="activeTab === 'documents'"
                  ><i class="bi bi-check-circle-fill"></i><span>Approval</span></button>

                  <!-- Document Warehouse -->
                  <button
                    v-if="$route.params.is_public === 'false'"
                    class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                    :class="{ active: activeTab === 'documents_warehouse' }"
                    @click="activeTab = 'documents_warehouse'"
                    id="tab-doc-warehouse"
                    data-bs-toggle="tab"
                    data-bs-target="#documents_warehouse"
                    type="button"
                    role="tab"
                    aria-controls="documents_warehouse"
                    :aria-selected="activeTab === 'documents_warehouse'"
                  ><i class="bi bi-folder-fill"></i><span>Files</span></button>
                </ul>
              </div>
            </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div :class="[(activeTab === 'documents_warehouse' || activeTab === 'members' || activeTab === 'personal_profiles') ? 'col-12 col-xl-12' : 'col-12 col-xl-12','col-lg-12','col-md-12','padpro-screen']">
            <div class="post-section h-150 full-width-mobile overflow-auto scrollable-container padding-x py-1">
              <div class="tab-content full-width-mobile w-100" id="pills-tabContent">
                <div class="tab-pane fade full-width-mobile padding-x" :class="{ 'show active': activeTab === 'your_feed' }" id="normal_loans_info" role="tabpanel" aria-labelledby="normal_loans_tab">
                  <CreateFeed ref="createFeedRef" v-if="token_exists && activeTab === 'your_feed'" :key="activeTab" :current_portal_permissions="current_portal_permissions" :current_organization_permissions="current_organization_permissions" @new_report="addReportToHome" @report-updated="update_report_in_list" @addPortal="addNewPortal" @newSegment="addNewSegement" @new_temp_post="addTemporaryPost" @remove_temp_post="removeTemporaryPost"
                  :active-profile="activeProfile"/>
                  <div class="temporary-post posting-loader-card" v-if="temporaryPost" id="temp-post">
                    <div class="posting-loader-icon" aria-hidden="true">
                      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                    </div>
                    <div class="posting-loader-content">
                      <div class="d-flex align-items-center justify-content-between gap-2">
                        <p class="mb-0 fw-bold text-xs">Posting your feed</p>
                        <span class="posting-loader-status">Saving</span>
                      </div>
                      <p class="mb-2 text-muted text-xxs text-truncate">{{ temporaryPost.report_name || 'Feed' }}</p>
                      <div class="posting-loader-track" aria-hidden="true">
                        <span></span>
                      </div>
                    </div>
                  </div>
                  <div  v-if ="is_report_loading && reports.length === 0" class="text-center py-5 w-100">
                    <div class="spinner-border text-secondary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2 mb-0 text-muted">Loading feeds...</p>
                  </div>
              <div v-else>
                <div ref="scrollContainer" @scroll="handleScroll" class="scrollable-container mb-5">
                  <div v-if="reports.length > 0">
                  <div v-for="report in reports"
                    :key="report.id"
                    :id="'post-' + report.id"
                    class="card card-hover mb-4 p-3 d-flex flex-column border-bottom rounded border-0 full-width-mobile shadow">
                  <div class="row">
                    <div class="col">
                    <div class="d-flex align-items-start gap-3">
                      <div v-if= "!client_features.show_report_author" class="profile-avatar-wrapper">

                    <img
                      v-if="get_profile_picture(report)":src="get_profile_picture(report)"
                      loading="lazy"class="profile-list-avatar pointer flex-shrink-0"
                      alt="Profile Picture">
                    <i v-else
                      class="bi bi-person-circle fs-3 text-dark pointer"
                    ></i>
                  </div>
                         <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="pe-2">
                            <!-- Name / Company + topic + pin -->
                            <p v-if= "!client_features.show_report_author" class="fw-500 mb-1 lh-base small">
                              <span v-if="report?.base_profile?.user?.is_blocked">
                                Unknown User
                              </span>
                              <span v-else-if="report?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'"
                              @click="view_profile(report.base_profile?.user?.id)" >
                                {{ report.base_profile?.user?.first_name }} {{ report.base_profile?.user?.last_name }}
                              </span>
                              <span v-else @click="view_company(report)">
                                {{ report.base_profile?.company?.company_name || 'Company Name' }}
                              </span>

                              <span v-if="report?.topic" class="badge bg-warning text-dark ms-2 align-middle">
                                <i class="bx bxs-bulb me-1"></i>{{ report.topic?.name }}
                              </span>

                              <span v-if="report.is_pinned" class="ms-2 text-warning align-middle">
                                <i class="bx bxs-pin"></i>
                              </span>
                              <span v-if="report.is_admin_edited" class="ms-1  align-middle">
                                <small class="text-muted mb-2 text-xxs fst-italic">
                                  <i class="bx bx-edit mb-1"></i> Edited by Admin
                                </small>
                              </span>
                              <span v-else-if="report.is_edited" class="ms-2 align-middle">
                                <small class="text-muted text-xxs fst-italic">
                                  <i class="bx bx-edit me-1"></i> Edited
                                </small>
                              </span>
                            </p>

                            <!-- Date -->
                            <p v-if="!client_features.show_report_author" class="text-muted small mb-0 d-flex align-items-center gap-1">
                              <i class="bx bxs-stopwatch"></i>
                              <span>{{ report.publication_date }}</span>
                            </p>
                          </div>




                          <!-- Three Dots Menu -->
                          <div
                            class="dropstart ms-2"
                            @click.stop
                            v-if="(String(report.base_profile?.user?.id) === String(user_details.user_id) && token_exists) || user_details.user_role === 'admin'"
                          >
                            <a href="" class="text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                              <i class="bi bi-three-dots-vertical"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end lh-sm" aria-labelledby="dropdownMenuButton" @click="hide_dropdown_menu">
                              <a
                                v-if="user_details.user_role === 'admin'"
                                class="dropdown-item small fw-bold border-bottom"
                                href=""
                                @click.prevent="togglePinReport(report)"
                              >
                                <i :class="report.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                                {{ report.is_pinned ? 'Unpin' : 'Pin' }}
                              </a>
                              <li
                                v-if="user_details.user_role === 'admin' || String(report.base_profile?.user?.id) === String(user_details.user_id)"
                              >
                                <a
                                  class="dropdown-item small fw-bold"
                                  href=""
                                  @click.prevent="open_feed_edit_report(report)"
                                  v-if="report.total_comments === 0 && report.total_likes === 0"
                                >
                                  <i class="bx bxs-edit fs-6"></i> Edit
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item small fw-bold d-none" href="" @click.prevent="open_event_modal(report.id)">
                                  <i class="bi bi-calendar-event fs-6"></i> Add Event
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item small fw-bold" href="" @click.prevent="deleteReport(report.id)">
                                  <i class="bx bxs-trash-alt fs-6"></i> Delete
                                </a>
                              </li>
                            </ul>
                          </div>


                        </div>
                      </div>
                      </div>

                      <!-- Report Description -->
                      <p class="fw-500 text-xxs mt-2" v-if="report.name">{{ report.name }}</p>
              <div class="quill-wrapper">
                    <div
                      v-html="displayedDescription(report)"
                      class="ql-editor quill-content fs-6 lh-lg">
                    </div>

        <!-- Read More / Read Less Toggle -->
        <span v-if="report.description.length > maxLength" class="text-secondary cursor-pointer text-xxs ms-1"
          @click="toggleDescription(report.id)">
          {{ isExpanded(report.id) ? ' Read Less' : 'Read More' }}
          <i v-if="!isExpanded(report.id)" class="bx bx-down-arrow-circle"></i>
          <i v-else class="bx bx-up-arrow-circle"></i>
        </span>
                  </div>

                      <!-- Images -->
                       <!-- ✅ IMAGE FILES -->
                      <div
                        v-if="getCarouselImages(report).length"
                        class="feed-media-grid mb-2"
                        :class="`feed-media-grid--${Math.min(getCarouselImages(report).length, 4)}`"
                      >
                        <button
                          v-for="(src, i) in getCarouselImages(report).slice(0, 4)"
                          :key="src?.id || src?.file?.id || `portal-media-${report.id}-${i}`"
                          type="button"
                          class="feed-media-tile"
                          :aria-label="`Open image ${i + 1} of ${getCarouselImages(report).length}`"
                          @click.stop="display_comment_modal(report)"
                        >
                          <img
                            :src="src?.file?.url"
                            :alt="`${report.name || 'Portal feed'} image ${i + 1}`"
                            loading="lazy"
                          >
                          <span
                            v-if="i === 3 && getCarouselImages(report).length > 4"
                            class="feed-media-more"
                            aria-hidden="true"
                          >
                            +{{ getCarouselImages(report).length - 4 }}
                          </span>
                        </button>
                      </div>
                  <div class="d-flex flex-column" v-if="getNonImageReportFiles(report).length">
                    <div
                      v-for="(fileObj, index) in getNonImageReportFiles(report)"
                      :key="fileObj?.id || fileObj?.file?.id || index"
                      class="mb-3"
                    >
                    <!-- ✅ IMAGE FILES -->
                    <div
                      class="media-container image-only mb-3"
                      v-if="fileObj?.file?.url &&
                            (fileObj.file.url.includes('.jpg') ||
                            fileObj.file.url.includes('.JPG') ||
                            fileObj.file.url.includes('.png') ||
                            fileObj.file.url.includes('.PNG') ||
                            fileObj.file.url.includes('.avif') ||
                            fileObj.file.url.includes('.AVIF') ||
                            fileObj.file.url.includes('.jpeg') ||
                            fileObj.file.url.includes('.JPEG') ||
                            fileObj.file.url.includes('.webp') ||
                            fileObj.file.url.includes('.WEBP'))"
                    >
                      <!-- <img
                        :src="fileObj.file.url"
                        alt="Feed Image"
                        class="media-item rounded"
                        @click="display_comment_modal(report)"
                      /> -->
                    </div>

                    <!-- ✅ AUDIO FILES -->
                    <div
                      class="media-container audio-post rounded mb-3"
                      v-else-if="fileObj?.file?.url &&
                                (fileObj.file.url.includes('.mp3') ||
                                  fileObj.file.url.includes('.wav'))"
                    >
                    <div class="audio-post-header">
                        <div class="audio-post-name">{{ getFileName(fileObj?.file?.url) }}</div>
                      </div>
                      <audio controls class="audio-post-player">
                            <source :src="fileObj.file.url"
                              :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'" />
                            Your browser does not support the audio element.
                          </audio>
                    </div>

                    <!-- ✅ VIDEO FILES -->
                        <div class="media-container video-post mb-3"
                      v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)"
                    >
                      <video controls class="media-item rounded" @click="display_comment_modal(report)">
                        <source :src="fileObj.file.url" />
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    <!-- ✅ OTHER FILES (PDF, DOCX, ZIP, ETC.) -->
                    <div v-else
                        class="uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm"
                        @click="open_preview(fileObj)">
                        <!-- File Info -->
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                          <div class="d-flex align-items-center justify-center me-3 flex-shrink-0">
                            <img
                              v-if="fileObj?.file?.url"
                              :src="getFileIcon(fileObj.file.url)"
                              class="file-icon"/>
                          </div>

                          <div class="file-details">
                            <span class="file-name d-block">
                              {{ getFileName(fileObj?.file?.url) }}
                            </span>
                          </div>
                        </div>
                        <!-- Actions -->
                        <div class="d-flex align-items-center gap-3 flex-shrink-0 ms-3">
                          <a
                            :href="fileObj?.file?.url"
                            download
                            :title="getFileName(fileObj?.file?.url)"
                            class="file-action-btn"
                            @click.stop
                          >
                            <i class="bi bi-download"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                                              <div v-if="report.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border">

                        <a :href="report.report_link" target="_blank" class="stretched-link text-decoration-none">
                        <img v-if="report.linkPreview.image" :src="report.linkPreview.image" class="img-fluid rounded" />
                        <div class="fw-bold mt-2">{{ report.linkPreview.title }}</div>
                        <div v-if="!report.linkPreview.image" class="text-muted small">{{ report.linkPreview.description }}</div>
                        </a>
                      </div>

                      <!-- Likes and Comments Count -->
                      <div class="text-gray mx-2 mt-1 text-end">
                        <span class="me-2" @click="open_likes_modal(report.likes)" data-bs-toggle="modal" data-bs-target="#likes_modal">
                          {{ report.total_likes }}
                          <i class="bi bi-hand-thumbs-up ms-1 align-middle text-muted" aria-hidden="true"></i>
                        </span>
                        <span>{{ report.total_comments }}
                          <i class="bi bi-chat ms-1 align-middle text-muted" aria-hidden="true"></i>
                        </span>
                      </div>

                      <!-- Action Buttons -->
                      <div class="d-flex justify-content-between align-items-center border-top border-bottom px-2 py-1 flex-wrap mb-2">
                        <div class="d-flex align-items-center me-3">
                        <!-- Like button -->
                        <span v-if="!likedReports[report.id]" class="d-flex align-items-center fw-500 pointer"
                          @click.stop="likeReport(report)">
                          <i class="bi bi-hand-thumbs-up text-black pointer"></i>
                          <span class="text-purple text-xxs mx-1">Like</span>
                        </span>

                        <!-- Unlike button -->
                        <span v-else class="d-flex align-items-center fw-500 pointer"
                          @click.stop="unlikeReport(report)">
                          <i class="bi bi-hand-thumbs-up-fill text-black pointer text-xs"></i>
                          <span class="text-xxs mx-1">Unlike</span>
                        </span>

                      </div>
                      <div :class="`d-flex align-items-center me-3 ${!report.can_comment ? 'comment-disabled' : 'pointer'}`" @click="toggle_comment(report.id)">
                        <i class="bi bi-chat fw-bold pointer text-xs"></i>
                        <span class="fw-500 text-xxs mx-1">Comment</span>
                      </div>


            <!-- Share Menu -->
                <div class="d-flex align-items-center me-2 menu mt-1" @click.stop>
                  <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open" name="menu-open" />
                  <label :for="'menu-open-' + report.id" class="menu-open-button d-flex align-items-center" @click="boon">
                    <i class="bi bi-share-fill" aria-hidden="true"></i>
                    <span class="mx-1 fw-500 t">Share</span>
                  </label>

                  <!-- Copy Link -->
                  <a @click="copyReportLinkToClipboard(report)" class="menu-item bg-white">
                    <span @click="closeMenu(report.id)">
                      <i class="bi bi-link fs-4 copy text-primary text-xxs"></i>
                    </span>
                  </a>

                  <!-- Facebook -->
                  <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                    target="_blank" class="menu-item facebook-share-btn bg-white" @click="closeMenu(report.id)">
                    <i class="bi bi-facebook"></i>
                  </a>

                  <!-- Twitter -->
                  <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                    target="_blank" class="menu-item twitter-share-btn bg-white" @click="closeMenu(report.id)">
                    <i class="bi bi-twitter-x"></i>
                  </a>

                  <!-- Gmail -->
                  <a :href="'mailto:?subject=Check%20this%20out&body=' + encodeURIComponent(baseUrl(report,'report'))"
                    target="_blank" class="menu-item gmail-share-btn bg-white" @click="closeMenu(report.id)">
                    <i class="bi bi-google"></i>
                  </a>

                  <!-- LinkedIn -->
                  <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                    target="_blank" class="menu-item linkedin-share-btn bg-white" @click="closeMenu(report.id)">
                    <i class="bi bi-linkedin"></i>
                  </a>

                  <!-- WhatsApp -->
                  <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                    target="_blank" class="menu-item whatsapp-share-btn bg-white" @click="closeMenu(report.id)">
                    <i class="bi bi-whatsapp"></i>
                  </a>

                  <!-- Telegram -->
                  <a :href="'https://t.me/share/url?url=' + encodeURIComponent(baseUrl(report,'report'))"
                    target="_blank" class="menu-item telegram-share-btn bg-white" @click="closeMenu(report.id)">
                    <i class="bi bi-telegram"></i>
                  </a>

                  <!-- Copy Toast -->
                  <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
                    <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert"
                        aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body"></div>
                        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                                aria-label="Close"></button>
                      </div>
                    </div>
                  </div>
                </div>

                </div>
                      <div class="d-flex align-items-center border rounded mb-3 p-0" v-if="activeCommentReportId === report.id">
                        <div class="comment-avatar-wrapper me-2">
                          <img
                            v-if="get_profile_picture(activeProfile)"
                            :src="get_profile_picture(activeProfile)"
                            class="comment-avatar mx-2"
                            alt="Profile Picture"
                          >
                          <i
                            v-else
                            class="bi bi-person-circle fs-4 text-dark pointer mx-2"
                          ></i>
                        </div>

                        <input type="text" class="form-control border-0 rounded-5 text-xs" v-model="commentText" id="comment_text_area"
                          placeholder="Write a comment" @input="onCommentInput" />

                        <div class="d-flex align-items-center">
                          <button class="btn btn-sm text-xxs" type="button" @click="submit_comment(report.id)">
                            <i class="bi bi-send-fill fs-6"></i>
                          </button>
                        </div>
                      </div>

<!-- Suggestions Dropdown -->
<div v-if="showSuggestions && filteredUsers.length > 0" class="suggestions-dropdown modal-body-scroll">
  <div v-for="user in filteredUsers" :key="user.id" class="suggestion-item" @mousedown.prevent="selectUser(user)">
    {{ user.full_name }}
  </div>
</div>


                  <!-- Comments Component -->
                        <Comments
                        :comments="report.comments"
                        :report-id="report.id"
                        @add-comment="handleAddComment"
                        :activeProfile="activeProfile"
                      />




                </div>
        </div>
                  </div>
                  </div>

                  <div v-else class="text-center py-3">
            <p class="mt-2 mb-0 text-muted">No reports found.</p>
          </div>
                  <div ref="infiniteScrollSentinel" class="sentinel"></div>
                </div>
                <div v-if="is_report_loading" class="loading">Loading...</div>
              </div>
              </div>
              <div class="tab-pane fade full-width-mobile" :class="{ 'show active': activeTab === 'members' }" id="portal_members" role="tabpanel" aria-labelledby="portal_members_tab">
                <PortalMembers :is_public="is_public" :portal_admin="portal_admin" v-if="activeTab === 'members'" :active-tab="activeTab"/>
              </div>

              <div class="tab-pane fade full-width-mobile padding-x" :class="{ 'show active': activeTab === 'personal_profiles' }" id="personal_profiles" role="tabpanel" aria-labelledby="tab-personal-profiles">
                <PortalFormAnswers
                  v-if="activeTab === 'personal_profiles' && ((user_details.user_role === 'admin' || user_details.user_role === 'organization admin' || portal_admin) || String(portal_profile.creater_id) === String(user_details.user_id))"
                  :loading="loading_personal_profile_forms"
                  :personal_profile_forms_users="personal_profile_forms_users"
                />
                <PortalForm v-else/>
              </div>

              <div class="tab-pane fade full-width-mobile" id="portal_roles" role="tabpanel" aria-labelledby="portal_roles_tab"
                v-if="$route.params.is_public === 'false' && (user_details.user_role === 'admin' || String(portal_profile.creater_id) === String(user_details.user_id))">
              </div>
              <div class="tab-pane fade full-width-mobile" :class="{ 'show active': activeTab === 'mentors' }" id="portal_mentors" role="tabpanel" aria-labelledby="portal_mentors_tab">
                <PortalMentors :is_public="is_public" :portal_admin="portal_admin"  v-if="activeTab === 'mentors'" :active-tab="activeTab"/>
              </div>
              <div class="tab-pane fade full-width-mobile" :class="{ 'show active': activeTab === 'mentees' }" id="portal_mentees" role="tabpanel" aria-labelledby="portal_mentees_tab">
                <PortalMentees :is_public="is_public" :portal_admin="portal_admin"  v-if="activeTab === 'mentees'" :active-tab="activeTab"/>
              </div>
              <div class="tab-pane fade mt-1 py-1 full-width-mobile" :class="{ 'show active': activeTab === 'requests' }" id="portal_requests" role="tabpanel" aria-labelledby="portal_requests_tab"
              v-if="((user_details.user_role === 'admin'|| user_details.user_role === 'organization admin'  || portal_admin) || String(portal_profile.creater_id) === String(user_details.user_id))">
                <PortalRequest :is_public="is_public" :portal_admin="portal_admin" v-if="activeTab === 'requests'" :active-tab="activeTab"/>
              </div>
              <div class="tab-pane fade mt-1 py-1" :class="{ 'show active': activeTab === 'documents' }" id="document_approval" role="tabpanel" aria-labelledby="document_approval_tab">
                <div class="d-flex align-items-center temporary-post" v-if="temporaryPost" id="temp-post">
                  <p class="text-xxs fw-bold">{{ temporaryPost.document_name }} - Posting...</p>
                  <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
                </div>
                <DocumentApproval ref="documentApprovalRef" :is_public="is_public" :portal_admin="portal_admin" v-show="activeTab === 'documents'" :active-tab="activeTab"/>
              </div>

              <!-- document warehouse -->
              <div class="tab-pane fade mt-1 py-1 full-width-mobile padding-x" :class="{ 'show active': activeTab === 'events' }" id="events" role="tabpanel" aria-labelledby="events">
                <div class="d-flex align-items-center temporary-post" v-if="temporaryPost" id="temp-post">
                  <p class="text-xxs fw-bold">{{ temporaryPost.document_name }} - Posting...</p>
                  <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
                </div>
                <PortalEvents  :is_public="is_public" :portal_admin="portal_admin" v-if="activeTab === 'events'"/>
              </div>

              <div class="tab-pane fade" :class="{ 'show active': activeTab === 'documents_warehouse' }" id="documents_warehouse" role="tabpanel" aria-labelledby="documents_warehouse">
                <div class="d-flex align-items-center temporary-post" v-if="temporaryPost" id="temp-post">
                  <p class="text-xxs fw-bold">{{ temporaryPost.document_name }} - Posting...</p>
                  <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
                </div>
                <DocumentWarehouse  :is_public="is_public" :portal_admin="user_details.user_role === 'admin' || user_details.user_role === 'organization admin' || portal_admin" :current_portal_permissions="current_portal_permissions" :user_details="user_details" v-if="activeTab === 'documents_warehouse'"/>
              </div>

              <div
                class="tab-pane fade full-width-mobile padding-x"
                :class="{ 'show active': activeTab === 'permissions' }"
                id="portal_permissions"
                role="tabpanel"
                aria-labelledby="tab-portal-permissions"
                v-if="(user_details.user_role === 'admin' || user_details.user_role === 'organization admin' || portal_admin) && $route.params.is_public === 'false'"
              >
                <div class="portal-permissions-panel bg-white border rounded shadow-sm p-3 mt-1">
                  <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-3">
                    <div>
                      <p class="mb-1 fw-bold text-sm">Portal Permissions</p>
                      <p class="mb-0 text-muted text-xxs">Manage what members can create, edit, upload, download, delete, and review.</p>
                    </div>
                  </div>

                  <div class="mb-3">
                    <input
                      type="text"
                      v-model="searchQuery"
                      @input="searchUsers"
                      placeholder="Search users by name or email"
                      class="form-control form-control-sm text-xs"
                    />
                  </div>

                  <div v-if="loading_members" class="text-center py-4">
                    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                    <p class="mb-0 mt-2 text-muted text-xxs">Loading permissions...</p>
                  </div>

                  <div v-else>
                    <div
                      v-for="(user, index) in portal_permissions.filter(u => u.portal_access?.user)"
                      :key="user.portal_access.id"
                      :class="['portal-permission-row p-3 mb-2 rounded', index % 2 === 0 ? 'bg-white' : 'bg-light']"
                    >
                      <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2">
                        <div class="flex-grow-1 mb-2 mb-md-0 min-w-0">
                          <strong class="text-xs d-block text-truncate">{{ user.portal_access?.user.first_name }} {{ user.portal_access?.user.last_name }}</strong>
                          <small class="text-muted d-block text-truncate">{{ user.portal_access?.user.email }}</small>
                        </div>

                        <div class="d-flex flex-wrap gap-2 justify-content-start justify-content-md-end">
                          <div class="form-check">
                            <input class="form-check-input form-check-input-sm" type="checkbox" v-model="user.create" @change="handle_permission_change(user, 'create')" :id="'permissions-tab-create-' + user.portal_access?.id">
                            <label class="form-check-label text-xxs" :for="'permissions-tab-create-' + user.portal_access?.id">Create</label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input form-check-input-sm" type="checkbox" v-model="user.edit" @change="handle_permission_change(user, 'edit')" :id="'permissions-tab-edit-' + user.portal_access?.id">
                            <label class="form-check-label text-xxs" :for="'permissions-tab-edit-' + user.portal_access?.id">Edit</label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input form-check-input-sm" type="checkbox" v-model="user.upload" @change="handle_permission_change(user, 'upload')" :id="'permissions-tab-upload-' + user.portal_access?.id">
                            <label class="form-check-label text-xxs" :for="'permissions-tab-upload-' + user.portal_access?.id">Upload</label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input form-check-input-sm" type="checkbox" v-model="user.download" @change="handle_permission_change(user, 'download')" :id="'permissions-tab-download-' + user.portal_access?.id">
                            <label class="form-check-label text-xxs" :for="'permissions-tab-download-' + user.portal_access?.id">Download</label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input form-check-input-sm" type="checkbox" v-model="user.delete" @change="handle_permission_change(user, 'delete')" :id="'permissions-tab-delete-' + user.portal_access?.id">
                            <label class="form-check-label text-xxs" :for="'permissions-tab-delete-' + user.portal_access?.id">Delete</label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input form-check-input-sm" type="checkbox" v-model="user.review" @change="handle_permission_change(user, 'review')" :id="'permissions-tab-review-' + user.portal_access?.id">
                            <label class="form-check-label text-xxs" :for="'permissions-tab-review-' + user.portal_access?.id">Review</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="!portal_permissions.filter(u => u.portal_access?.user).length" class="text-center text-muted text-xs py-4">
                      No portal members found.
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
              class="tab-pane fade"
              id="sub_portals"
              role="tabpanel"
              aria-labelledby="sub_portals_tab_md"
            >
            <SubPortalView v-if="activeTab === 'sub_portals'"/>

            </div> -->
              <div class="tab-pane fade" :class="{ 'show active': activeTab === 'voice' }" id="top_loans_info" role="tabpanel" aria-labelledby="top_loans_tab" >
                <SurveyView ref="portalSurveyView" v-if="activeTab === 'voice'"/>
              </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT (Boards, Segments, and Members) -->
      <div v-if="activeTab !== 'personal_profiles'" class="col-xl-3 col-lg-3 d-lg-block ps-lg-0">
        <div class="d-none d-xl-block mt-2">
          <div v-if="isLoading" class="portal-sidebar-card-compact">
            <div class="portal-sidebar-body text-center py-4 px-3">
              <div class="spinner-border spinner-border-sm text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Boards...</p>
            </div>
          </div>

          <div v-else-if="boards && boards.length" class="portal-sidebar-card-compact">
            <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
              <h6 class="mb-0">Boards</h6>
              <button
                v-if="can_create_portal_content"
                class="portal-sidebar-avatar border-0"
                data-bs-toggle="modal"
                data-bs-target="#create_board_modal"
                aria-label="Create board"
              >
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>

            <div class="portal-sidebar-body">
              <div class="portal-sidebar-list d-flex flex-column">
                <div
                  v-for="board in visible_desktop_boards"
                  :key="board.id"
                  class="portal-sidebar-item cursor-pointer"
                  role="button"
                  tabindex="0"
                  @click="handleBoardClick(board)"
                  @keyup.enter="handleBoardClick(board)"
                >
                  <span class="portal-sidebar-avatar">
                    {{ getInitials(board.name || 'Board') }}
                  </span>
                  <span class="portal-sidebar-name">
                    {{ board.name }}
                  </span>
                  <div
                    v-if="String(board?.created_by?.user?.id) === String(user_details?.user_id) || user_details.user_role === 'admin'"
                    class="dropdown"
                    @click.stop
                  >
                    <button
                      class="btn btn-sm border-0 p-0 d-inline-flex align-items-center justify-content-center"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-label="Board actions"
                    >
                      <i class="bx bx-dots-vertical-rounded cursor-pointer"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item text-xs" data-bs-toggle="modal" data-bs-target="#edit_board_modal" href="" @click="openEditBoardModal(board)">Edit</a>
                      </li>
                      <li>
                        <a class="dropdown-item text-xxs text-danger" href="#" @click="deleteBoard(board.id)">Delete</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <button
                v-if="has_more_desktop_boards"
                type="button"
                class="portal-sidebar-see-all btn btn-link btn-sm w-100 text-decoration-none"
                @click="toggle_desktop_boards"
              >
                {{ show_all_desktop_boards ? 'See Less' : 'See All' }}
              </button>
            </div>
          </div>

          <div v-if="!isLoading && !boards.length" class="portal-sidebar-card-compact">
            <div class="portal-sidebar-body text-center py-4 px-3">
              <button
                class="portal-sidebar-avatar border-0 mb-3"
                data-bs-toggle="modal"
                data-bs-target="#create_board_modal"
                aria-label="Create board"
              >
                <i class="bi bi-plus-lg"></i>
              </button>
              <h6 class="fw-bold mb-1">No boards yet</h6>
              <p class="text-muted text-xxs mb-0">Create your first board to get started.</p>
            </div>
          </div>
        </div>

        <!-- Topics (Your Feed / Voice) -->
      <div class="d-none">
      <AllTopics
          v-if="activeTab === 'your_feed' || activeTab === 'voice'"
          @topic_selected="handleTopicSelected"
          :topics="topics"
          ref="topics"
          @newSegment="addNewSegement"  @clear_reports="clear_reports_filter"
        />
      </div>

        <PortalRoles
          v-if="activeTab === 'members'"
          ref="portalRoles"
          class="as-right-rail d-none d-xl-block"
          :portal_id="$route.params.portal_id"
          :is_public="false"
          :portal_admin="user_details?.user_role === 'admin' || portal_admin"
        />
        <AllGroups  :groups="groups" ref="groups" />
      </div>

      <!-- Boards Offcanvas -->
<div
  class="offcanvas offcanvas-start"
  tabindex="-1"
  id="boards_offcanvas"
  aria-labelledby="boardsLabel"
>
  <div class="offcanvas-body">

    <!-- Header -->
    <div class="d-flex justify-content-between mt-5">
      <div class="d-flex align-items-center mt-3">
        <h5 class="offcanvas-title mx-2" id="boards_label">Boards</h5>

      </div>

      <button
        type="button"
        class="btn-close text-reset mt-4"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>


    <!-- Loading -->
    <div v-if="isLoading" class="portal-sidebar-card border mt-3">
      <div class="portal-sidebar-body text-center py-4 px-3">
        <div class="spinner-border spinner-border-sm text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 mb-0 text-muted text-xxs">Loading Boards...</p>
      </div>
    </div>


    <!-- Boards List -->
    <div v-if="boards.length && !isLoading" class="portal-sidebar-card portal-sidebar-card-list mt-3">
      <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
        <h6 class="mb-0">All Boards</h6>
        <button
          class="portal-sidebar-avatar border-0"
          @click="openCreateBoardModal"
          aria-label="Create board"
        >
          <i class="bi bi-plus-lg"></i>
        </button>
      </div>
      <div class="portal-sidebar-body">
        <div class="portal-sidebar-list d-flex flex-column">
          <div
            v-for="board in boards"
            :key="board.id"
            class="portal-sidebar-item cursor-pointer"
            role="button"
            tabindex="0"
            @click="handleBoardClick(board)"
            @keyup.enter="handleBoardClick(board)"
          >
            <span class="portal-sidebar-avatar">
              {{ getInitials(board.name || 'Board') }}
            </span>
            <span class="portal-sidebar-name">
              {{ board.name }}
            </span>
            <div
              v-if="String(board?.created_by?.user?.id) === String(user_details?.user_id) || user_details.user_role === 'admin'"
              class="dropdown"
              @click.stop
            >
              <button
                class="btn btn-sm border-0 p-0 d-inline-flex align-items-center justify-content-center"
                type="button"
                data-bs-toggle="dropdown"
                aria-label="Board actions"
              >
                <i class="bx bx-dots-vertical-rounded cursor-pointer"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a
                    class="dropdown-item text-xs"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_board_modal"
                    @click="openEditBoardModal(board)"
                  >Edit</a>
                </li>

                <li>
                  <a
                    class="dropdown-item text-danger text-xs"
                    @click="deleteBoard(board.id)"
                  >Delete</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isLoading && !boards.length" class="portal-sidebar-card border mt-3">
      <div class="portal-sidebar-body text-center py-4 px-3">
        <button
          class="portal-sidebar-avatar border-0 mb-3"
          @click="openCreateBoardModal"
          aria-label="Create board"
        >
          <i class="bi bi-plus-lg"></i>
        </button>
        <h6 class="fw-bold mb-1">No boards yet</h6>
        <p class="text-muted text-xxs mb-0">Create your first board to get started.</p>
      </div>
    </div>

  </div>
</div>



    </div>
  </div>





</section>

<StickyNav :active-tab="activeTab" class="d-xl-none" @select-voice-tab="handle_portal_mobile_voice_tab"/>


<!-- Commenting modal -->
<ReportCommentModal v-if="comment_modal_visible"
  :report_data="report_data" :portal_admin="portal_admin"
  @hide_comment_comment="hide_comment_comment"
/>
<SprintAgentModal ref="sprintAgentModal" :sprint_data="sprint_data" :portal_admin="portal_admin"/>


<teleport to="body">
<div class="modal fade" id="forwardReportModal" tabindex="-1" aria-labelledby="forwardModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow-sm border-0 p-3 bg-white">

      <div class="modal-header border-0 pb-1">
        <h6 class="modal-title fw-bold text-dark" id="forwardModalLabel">
          <i class="bi bi-box-arrow-up-right text-primary me-2"></i> Forward Report
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body pt-2">
        <p class="text-muted small mb-3">Select a portal to forward this report:</p>

        <div class="d-grid gap-2">
          <button
            v-for="portal in portals"
            :key="portal.id"
            @click="forwardReport(reportToForward, portal.id)"
            class="btn btn-light d-flex align-items-center justify-content-between rounded-pill px-3 py-2 shadow-sm"
          >
            <span class="fw-medium">{{ portal.name }}</span>
            <i class="bi bi-arrow-right text-muted small"></i>
          </button>

          <div v-if="portals.length === 0" class="text-center text-muted small mt-2">
            No portals to show
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="manage_portal_permissions_modal" tabindex="-1" aria-labelledby="managePortalPermissionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500">Manage Portal Permissions - {{$route.params.portal_name}}</p>
        <!-- Close button on the end with white "X" -->
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <!-- Search -->
        <div class="mb-3">
          <input type="text" v-model="searchQuery" @input="searchUsers"
                 placeholder="Search users by name or email"
                 class="form-control form-control-sm" />
        </div>

        <!-- Permissions List -->
<div v-for="(user, index) in portal_permissions.filter(u => u.portal_access?.user)"
     :key="user.portal_access.id"
             :class="['p-3 mb-2 rounded shadow-sm', index % 2 === 0 ? 'bg-white' : 'bg-light']">

          <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center">

            <!-- User Info -->
            <div class="flex-grow-1 mb-2 mb-md-0">
              <strong>{{ user.portal_access?.user.first_name }} {{user.portal_access?.user.last_name}} </strong><br>
              <small class="text-muted">{{ user.portal_access?.user.email }}</small>
            </div>

            <!-- Permissions Checkboxes -->
            <div class="d-flex flex-wrap gap-2 justify-content-start justify-content-md-end">
              <div class="form-check">
                <input class="form-check-input form-check-input-sm" type="checkbox"
                      v-model="user.create"
                      @change="handle_permission_change(user, 'create')"
                      :id="'create-' + user.portal_access?.id">
                <label class="form-check-label" :for="'create-' + user.portal_access?.id">Create</label>
              </div>
              <div class="form-check">
                <input class="form-check-input form-check-input-sm" type="checkbox"
                      v-model="user.edit"
                      @change="handle_permission_change(user, 'edit')"
                      :id="'edit-' + user.portal_access?.id">
                <label class="form-check-label" :for="'edit-' + user.portal_access?.id">Edit</label>
              </div>
              <div class="form-check">
                <input class="form-check-input form-check-input-sm" type="checkbox"
                      v-model="user.upload"
                      @change="handle_permission_change(user, 'upload')"
                      :id="'upload-' + user.portal_access?.id">
                <label class="form-check-label" :for="'upload-' + user.portal_access?.id">Upload</label>
              </div>
              <div class="form-check">
                <input class="form-check-input form-check-input-sm" type="checkbox"
                      v-model="user.download"
                      @change="handle_permission_change(user, 'download')"
                      :id="'download-' + user.portal_access?.id">
                <label class="form-check-label" :for="'download-' + user.portal_access?.id">Download</label>
              </div>
              <div class="form-check">
                <input class="form-check-input form-check-input-sm" type="checkbox"
                      v-model="user.delete"
                      @change="handle_permission_change(user, 'delete')"
                      :id="'delete-' + user.portal_access?.id">
                <label class="form-check-label" :for="'delete-' + user.portal_access?.id">Delete</label>
              </div>
              <div class="form-check">
                <input class="form-check-input form-check-input-sm" type="checkbox"
                      v-model="user.review"
                      @change="handle_permission_change(user, 'review')"
                      :id="'review-' + user.portal_access?.id">
                <label class="form-check-label" :for="'review-' + user.portal_access?.id">Review</label>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>
</teleport>

<div class="modal fade" id="create_board_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Create Board</p>
        <!-- Close button on the end with white "X" -->
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
      </div>
      <div class="modal-body">
        <label for="portal_name" class="form-label text-xs fw-500 ms-1">Board Name: <span class="text-danger">*</span></label>
        <input type="text" class="form-control rounded text-xs shadow-sm" placeholder="Enter board name"
          v-model="board_name"  />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary text-xxs rounded" @click="create_portal_board" data-bs-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</div>
<teleport to="body">
    <div class="modal fade" id="likes_modal" tabindex="-1" aria-labelledby="likes_modal_label" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-3">
          <div class="modal-header bg-primary text-white position-relative">
            <h5 class="modal-title fw-bold" id="likes_modal_label">
              <span class="mt-5">Likes</span>
            </h5>
            <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
          </div>

          <div class="modal-body pt-2">
            <ul class="list-group list-group-flush scrollable-container h-50px">
              <li v-for="user in modal_likes" :key="user.id"
                class="list-group-item d-flex align-items-center px-0 border-bottom">
                <!-- Profile image -->
                <div class="position-relative me-3">
                  <img :src="user?.user?.profile_picture || 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/user.webp'"
                    class="rounded-circle border" width="48" height="48" alt="Profile">
                  <!-- Reaction overlay -->
                  <span
                    class="reaction-overlay-badge position-absolute bottom-0 end-0 rounded-circle border border-white bg-primary text-white d-inline-flex align-items-center justify-content-center"
                  >
                    <i class="reaction-overlay-icon bi bi-hand-thumbs-up-fill" aria-hidden="true"></i>
                  </span>
                </div>

                <!-- Name & mutual friend -->
                <div class="fw-semibold">
                  <span v-if="user?.user?.is_blocked">Unknown User</span>
                  <span v-else @click="view_profile(user?.user.id)">
                    {{ user?.user.first_name }} {{ user?.user.last_name }}
                  </span>
                </div>
              </li>
            </ul>

            <p v-if="modal_likes.length === 0" class="text-muted text-center mt-3">
              No likes yet.
            </p>
          </div>
        </div>
      </div>
    </div>
  </teleport>

<teleport to="body">
  <div class="modal fade" id="edit_board_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xxs fw-500">Edit Board</p>
          <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="updateBoard">
          <div class="modal-body">
            <div class="mb-3">
              <label for="board_name" class="form-label text-xxs fw-500">Board Name <span
                  class="text-danger">*</span></label>
              <input
                type="text"
                id="board_name"
                class="form-control rounded text-xxs"
                v-model="board_name"
              />
              <p v-if="errors.board_name" class="text-danger text-xxs">{{ errors.board_name }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded-3 shadow-sm">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

 <teleport to="body">
  <div class="modal fade" id="preview_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">Preview</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body text-center position-relative">

          <!-- Loader Spinner -->
          <div v-if="loading_preview" class="d-flex justify-content-center align-items-center" width="100%" height="100%">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <!-- PDF Preview -->
          <div v-if="preview_type === 'pdf'" class="ratio ratio-16x9">
            <iframe :src="preview_url" width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
          </div>

          <!-- Image Preview -->
          <div v-else-if="preview_type === 'image'">
            <img :src="preview_url" class="img-fluid rounded" @load="on_content_loaded" />
          </div>

          <!-- Video Preview -->
          <div v-else-if="preview_type === 'video'">
            <video controls class="img-fluid rounded" @loadedmetadata="on_content_loaded">
              <source :src="preview_url" :type="'video/' + preview_url.split('.').pop()" />
              Your browser does not support the video tag.
            </video>
          </div>

          <!-- Audio Preview -->
          <div v-else-if="preview_type === 'audio'">
            <audio controls class="w-100 my-3" @loadedmetadata="on_content_loaded">
              <source :src="preview_url" :type="'audio/' + preview_url.split('.').pop()" />
              Your browser does not support the audio element.
            </audio>
          </div>

          <!-- Office Documents (DOCX, XLSX, PPTX) -->
          <div v-else-if="preview_type === 'office'" class="ratio ratio-16x9">
            <iframe
              :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
              width="100%"
              height="100%"
              frameborder="0"
              @load="on_content_loaded"
            ></iframe>
          </div>

          <!-- Text Files (TXT, CSV) -->
          <div v-else-if="preview_type === 'text'">
            <iframe :src="preview_url" width="100%" height="500px" frameborder="0" @load="on_content_loaded"></iframe>
          </div>

          <!-- Other / Unsupported Files -->
          <div v-else @load="on_content_loaded">
            <p>Preview not available. You can
              <a :href="preview_url" target="_blank" download>download the file</a> to view it.
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</teleport>
